import { channelObjects } from './channels';

const IMAGE_DIRECTORY = '/listing-ui-assets/img';
const BUY_URL = `${IMAGE_DIRECTORY}/opengraph-buy.jpg`;
const RENT_URL = `${IMAGE_DIRECTORY}/opengraph-rent.jpg`;
const INVEST_URL = `${IMAGE_DIRECTORY}/opengraph-invest.jpg`;
const SOLD_URL = `${IMAGE_DIRECTORY}/opengraph-sold.jpg`;
const LEASED_URL = `${IMAGE_DIRECTORY}/opengraph-leased.jpg`;
const DEFAULT_URL = BUY_URL;

const opengraphImages = new Map([
  [channelObjects.ForSale, BUY_URL],
  [channelObjects.ForLease, RENT_URL],
  [channelObjects.Invest, INVEST_URL],
  [channelObjects.Sold, SOLD_URL],
  [channelObjects.Leased, LEASED_URL],
]);

export const getUrlForChannel = channelObject =>
  opengraphImages.get(channelObject) || DEFAULT_URL;
